export const SCOPE = "modules/referral/";

export const SEND_INVITATION = SCOPE + "SEND_INVITATION";
export const ACCEPT_INVITATION = SCOPE + "ACCEPT_INVITATION";

export const SEND_INSIDER_INVITATION = SCOPE + "SEND_INSIDER_INVITATION";

export const VALIDATE_INSIDER_INVITATION =
  SCOPE + "VALIDATE_INSIDER_INVITATION";



// WEBPACK FOOTER //
// ./src/modules/referral/types.js